import { render } from "./WhatCategoryRatingsChart.vue?vue&type=template&id=15e7ff48&ts=true"
import script from "./WhatCategoryRatingsChart.vue?vue&type=script&lang=ts"
export * from "./WhatCategoryRatingsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__